'use client';

import { useEffect, useRef } from 'react';

/**
 * A bar fixed to the bottom of the screen (the event page's Register bar)
 * publishes its height as `--bottom-bar-h` on <html>, so other fixed things
 * (notifications) can sit above it instead of on it. Hidden bar (display:
 * none on a wide screen) or unmounted bar = 0.
 */
export function useBottomBarOffset<T extends HTMLElement>() {
  const ref = useRef<T>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const root = document.documentElement;
    const publish = () => root.style.setProperty('--bottom-bar-h', `${el.offsetHeight}px`);
    publish();
    const observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(publish) : null;
    observer?.observe(el);
    window.addEventListener('resize', publish);
    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', publish);
      root.style.removeProperty('--bottom-bar-h');
    };
  }, []);

  return ref;
}
